export enum ChecklistCategoryAPIResponse {
  Construction = 'construction',
  Contracts = 'contracts',
}
